module.exports = __webpack_public_path__ + "static/media/whatsapp.bd9a5f48.svg";